module.exports = "/assets/data/556adbb5ddb2318ebf4f04f04e7139cd-TS17.data.json";